// extracted by mini-css-extract-plugin
export var activeDot = "_3k-c";
export var buttonContainer = "_3k-9";
export var channelButton = "_3k-a";
export var clickable = "_3k-d";
export var content = "_3k-0";
export var contentFull = "_3k-2";
export var contentThird = "_3k-1";
export var contentWrapper = "_3k-7";
export var description = "_3k-5";
export var heightShort = "_3k-f";
export var image = "_3k-3";
export var imageContainer = "_3k-4";
export var selectButton = "_3k-e";
export var spinnerContainer = "_3k-b";
export var titleContent = "_3k-8";
export var titleWrapper = "_3k-6";